// -----------------------------------------------------------------------------
// WARNING: this file is automatically generated by the app-install script.
//          Any change to this file will be overwritten when adding apps.
// -----------------------------------------------------------------------------

const apps = [];

export default apps;
